import { render } from "./WeeklyOrders.vue?vue&type=template&id=6058cda7&scoped=true"
import script from "./WeeklyOrders.vue?vue&type=script&lang=js"
export * from "./WeeklyOrders.vue?vue&type=script&lang=js"

import "./WeeklyOrders.vue?vue&type=style&index=0&id=6058cda7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6058cda7"]])

export default __exports__